import { format, parse, isValid } from "date-fns";

export const toDateFnsFormat = (uiFormat?: string): string => {
    switch (uiFormat) {
        case "DD/MM/YYYY": return "dd/MM/yyyy";
        case "MM/DD/YYYY": return "MM/dd/yyyy";
        case "DD-MM-YYYY": return "dd-MM-yyyy";
        case "MM-DD-YYYY": return "MM-dd-yyyy";
        case "YYYY-MM-DD": return "yyyy-MM-dd";
        case "YYYY/MM/DD": return "yyyy/MM/dd";
        case "DD MMM YYYY": return "dd MMM yyyy";
        case "MMM DD, YYYY": return "MMM dd, yyyy";
        case "DD MMMM YYYY": return "dd MMMM yyyy";
        case "MMMM DD, YYYY": return "MMMM dd, yyyy";
        default: return "dd/MM/yyyy";
    }
};

// export const safeFormatDate = (
//     value?: string | null,
//     backendFormat?: string,
//     userFormat?: string
// ): string => {
//     if (!value) return "-";

//     let parsed: Date;


//     if (value.includes("T")) {
//         parsed = new Date(value);
//     } else {
//         parsed = parse(value, backendFormat || "dd/MM/yyyy", new Date());
//     }

//     if (!isValid(parsed)) return "-";

//     const dateFnsFormat = toDateFnsFormat(userFormat);
//     return format(parsed, dateFnsFormat);
// };

export const safeFormatDate = (
    value?: string | null,
    backendFormat: string = "dd/MM/yyyy",
    userFormat?: string,
    showTime: boolean = false,
    showSeconds: boolean = false

): string => {
    if (!value) return "-";

    let parsed: Date;
    if (value.includes("T")) {
        parsed = new Date(value);
    } else {
        parsed = parse(value, backendFormat, new Date());
    }

    if (!isValid(parsed)) {
        parsed = new Date(value);
    }

    if (!isValid(parsed)) {
        console.error("Invalid date:", value);
        return "-";
    }

    const dateFnsFormat = toDateFnsFormat(userFormat);

    if (!showTime) {
        return format(parsed, dateFnsFormat);
    }

    const timeFormat = showSeconds ? "hh:mm:ss a" : "hh:mm a";

    return format(parsed, `${dateFnsFormat} ${timeFormat}`);
};

